import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "./App.tsx";
import Homepage from "./Pages/Homepage.tsx";
import Login from "./Pages/Login.tsx";
import VerifyEmail from "./Pages/VerifyEmail.tsx";
import Imprint from "./Pages/Imprint.tsx";
import Privacy from "./Pages/Privacy.tsx";
import RegistrationComplete from "./Pages/RegistrationComplete.tsx";
import { ErrorElement } from "./components/ErrorElement.tsx";
import {
  AcceptInvitation,
  ApplicationProcessForm,
  ApplicationProcessList,
  CandidateDashboard,
  CommitteeDashboard,
  CommitteeMemberList,
  ForgotPassword,
  OpenApplicationProcesses,
  Participation,
  ParticipationInApplicationProcess,
  ParticipationsInFieldOfStudyList,
  Registration,
  ResetPassword,
} from "./lazyPages.ts";

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorElement />,
    children: [
      {
        path: "/",
        element: <Homepage />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "registrieren",
        element: <Registration />,
      },
      {
        path: "registriert",
        element: <RegistrationComplete />,
      },
      {
        path: "email-verifizieren",
        element: <VerifyEmail />,
      },
      {
        path: "impressum",
        element: <Imprint />,
      },
      {
        path: "datenschutz",
        element: <Privacy />,
      },
      {
        path: "passwort-vergessen",
        element: <ForgotPassword />,
      },
      {
        path: "passwort-zuruecksetzen",
        element: <ResetPassword />,
      },
      {
        path: "bewerbung",
        element: <CandidateDashboard />,
      },
      {
        path: "bewerbung/bewerbung/:participationInApplicationProcessId",
        element: <ParticipationInApplicationProcess />,
      },
      {
        path: "bewerbung/offene-bewerbungen",
        element: <OpenApplicationProcesses />,
      },
      {
        path: "kommission",
        element: <CommitteeDashboard />,
      },
      {
        path: "kommission/:applicationProcessId/:fieldOfStudyId",
        element: <ParticipationsInFieldOfStudyList />,
      },
      {
        path: "kommission/:applicationProcessId/:fieldOfStudyId/:participationId",
        element: <Participation />,
      },
      {
        path: "einladung",
        element: <AcceptInvitation />,
      },
      {
        path: "verwaltung",
        element: <Navigate to="/verwaltung/bewerbungsphasen" replace />,
      },
      {
        path: "verwaltung/bewerbungsphasen",
        element: <ApplicationProcessList />,
      },
      {
        path: "verwaltung/bewerbungsphasen/neu",
        element: <ApplicationProcessForm />,
      },
      {
        path: "verwaltung/bewerbungsphasen/:applicationProcessId",
        element: <ApplicationProcessForm />,
      },
      {
        path: "verwaltung/kommission",
        element: <CommitteeMemberList />,
      },
    ],
  },
]);
